export const PAYMENT_FAILED_HEADING = "Oh no, your payment failed";
export const PAYMENT_FAILED_MESSAGE =
  "Don't worry, any amount debited will be refunded.";
export const PAYMENT_FAILURE_NAVIGATION_TEXT = "Please try again";

export const PAYMENT_SUCCESS_HEADING = "Payment successful 👍";
export const PAYMENT_SUCCESS_MESSAGE = "";
export const PAYMENT_SUCCESS_NAVIGATION_TEXT = "Checkout your classes";

export const PAYMENT_UNKNOWN_HEADING = "Payment status unknown";
export const PAYMENT_UNKNOWN_MESSAGE = "Please check back after some time";
export const PAYMENT_UNKNOWN_NAVIGATION_TEXT = "Go back to course";
